// extracted by mini-css-extract-plugin
export default {"pauseQrCodeOverlay":"GGKPd","open":"Mmz_8","qrCodeContainer":"NEVJl","textContainer":"DBBkk","title":"yR1Sx","description":"jxqTQ"};